export const API = {
	appConfig : 'v1/superpay-app-config',
  // AUTH
  login: 'v1/auth/login',
  sendOtpCode: 'v1/auth/sendOtpCode',
  validateOtpCode: 'v1/auth/validateOtpCode',
  register: 'v1/customers/register',
  emailIsRegistered: 'v1/customers/email-registered',
  updateProfile: 'v1/customers/update-profile',
  changePassword: 'v1/auth/change-password',
  // Funcionalidades con audiencia restringida ya resueltas para el usuario del token.
  featureFlags: 'v1/auth/feature-flags',
  forgotPassword: 'v1/auth/forgot-password',
  validateResetToken: 'v1/auth/validate-reset-token',
  resetPassword: 'v1/auth/reset-password',
  logout: 'v1/auth/logout',
  getMe: 'v1/auth/me',
  sseTicket: 'v1/auth/sse-ticket',
  migrateSession: 'v1/auth/migrate-session',
  registerTwoFa: 'v1/auth/register-twofa',
  validateTwoFaCode: 'v1/auth/validate-twofa',
  verifyCodeEmailTwoFa: 'v1/auth/verifyCodeEmailTwoFa',
  recoverySecretTwoFa: 'v1/auth/recover-twofa',
  disableTwoFa: 'v1/auth/disable-twofa',

  // WebAuthn / login biométrico (passkeys)
  webauthnRegistrationOptions: 'v1/auth/webauthn/registration-options',
  webauthnRegistrationVerify: 'v1/auth/webauthn/registration-verify',
  webauthnAuthenticationOptions: 'v1/auth/webauthn/authentication-options',
  webauthnAuthenticationVerify: 'v1/auth/webauthn/authentication-verify',
  webauthnCredentials: 'v1/auth/webauthn/credentials',
  webauthnStepUpOptions: 'v1/auth/webauthn/stepup/options',
  webauthnStepUpVerify: 'v1/auth/webauthn/stepup/verify',
  getSession: (sessionId: string) => `v1/auth/session/${sessionId}`,
  getZendeskJwt: 'v1/auth/zjwt',

  // PAYMENT
  getPayment: 'v1/paymentRequest/payment',
  processPayment: 'v1/paymentRequest/process-payment',
  failedPayment: 'v1/paymentRequest/failed-payment',
  savePaymentAsQr: 'v1/paymentRequest/save-payment-as-qr',
  loadPaymentAsQr: 'v1/paymentRequest/load-payment-as-qr',
  sendPaymentEmail: 'v1/paymentRequest/send-payment-email',
  getPaymentRequestsByLink: 'v1/paymentRequest/payment-link-requests',

  // PAYMENT LINK
  createPaymentLink: 'v1/payment-links',
  getPaymentLinks: 'v1/payment-links',
  getPaymentLinkByToken: 'v1/payment-links/by-token',
  updatePaymentLink: 'v1/payment-links',
  removePaymentLink: 'v1/payment-links',
  paylinkMovements: 'v1/movements/paylink-movements',

  // ECOTREEW
  cancelPaymentRequest: 'v1/ecotreew/cancel-payment-request',
  createPaymentRequest: 'v1/ecotreew/new-payment-request',

  // ACCOUNT_MANAGER:
  getTransactions: 'v1/accountManager/get_transactions',
  getBeneficiaries: 'v1/beneficiary/customer-beneficiaries',
  createBeneficiary: 'v1/beneficiary/create',
  deleteBeneficiary: 'v1/beneficiary',

  // BANK BENEFICIARIES
  getBankBeneficiaries: 'v1/bank-beneficiary/customer-bank-beneficiaries',
  createBankBeneficiary: 'v1/bank-beneficiary/create',
  deleteBankBeneficiary: 'v1/bank-beneficiary',

  getUserFromBeneficiaryId: 'v1/accountManager/get_user_from_beneficiary_id',
  setUserMetadata: 'v1/auth/update-user-metadata',

  getMyAccountsBalances: 'v1/bank-accounts/my-accounts-balances',
  getAccountInfo: 'v1/bank-accounts/account-with-customer',

  getBanks: 'v1/accountManager/get_banks',
  getPayments: 'v1/accountManager/get_payments',
  getExchangeRateInfo: 'v1/exchange-rate/convert',

  // EP_CARDS
  getUserVerificationStatus: 'v1/integrations/verification-status',

  // EVENTS:
  paymentEventsStream: 'v1/paymentEvents/stream_payment',
  transferEventsStream: 'v1/transaction-events/stream_customer',

  // COBROS DEL COMERCIO (payment requests del merchant dueño de la cuenta):
  merchantCollections: 'v1/paymentRequest/merchant',

  // MOVEMENTS:
  getMovementHistory: 'v1/movements/history',
	getMovementsStatistics: 'v1/movements/statistics',
	transfer: 'v1/movements/transfer',
	getTransaction: 'v1/movements/transaction',
	exportMovements: 'v1/movements/export',
	exportMovementsExcel: 'v1/movements/export-excel',
	uploadInvoice: 'v1/movements/upload-invoice',
	getInvoiceUrl: 'v1/movements/invoice-url',
	getInvoiceFile: 'v1/movements/invoice-file',

	// TRANSACTION NOTES:
	addTransactionNote: 'v1/movements/transaction-notes',
	getTransactionNotes: 'v1/movements/transaction-notes/list',
	getTransactionNotesCount: 'v1/movements/transaction-notes/count',
	updateTransactionNote: 'v1/movements/transaction-notes',
	deleteTransactionNote: 'v1/movements/transaction-notes',

  // TRANSACTION TYPES:
  getTransactionTypes: 'v1/transaction-types',

  // SERVICE CATALOG:
  getServiceCatalog: 'v1/service-catalog',

  // EXTRACTION REQUESTS:
  getExtractionRequests: 'v1/extraction-request/customer-extraction-requests',
  createExtractionRequest: 'v1/extraction-request/create',
  previewExtractionRequestFee: 'v1/extraction-request/fee-preview',
  updateExtractionRequest: 'v1/extraction-request',
  deleteExtractionRequest: 'v1/extraction-request',
  cancelExtractionRequest: 'v1/extraction-request',

	systemConfig: 'v2/system-config',
	

	getCompanies: 'v1/company',
	createCompany: 'v1/company/create',
	deleteCompany: 'v1/company',

	// BUSINESS KYC (KYC de empresa — cuentas business)
	businessKycNomenclators: 'v1/business-kyc/nomenclators',
	businessKycProvinces: 'v1/business-kyc/provinces',
	businessKycTowns: 'v1/business-kyc/towns',
	businessKycStatus: 'v1/business-kyc/status',
	businessKycSubmit: 'v1/business-kyc/submit',

	// MERCHANT INTEGRATION REQUESTS (solicitud de credenciales de merchant)
	merchantRequestCreate: 'v1/merchant-request',

	// PUSH NOTIFICATIONS (Web Push / VAPID)
	pushVapidPublicKey: 'v1/push/vapid-public-key',
	pushSubscribe: 'v1/push/subscribe',
  // Unsubscribe uses DELETE against the same subscribe resource endpoint.
  pushUnsubscribe: 'v1/push/subscribe',

	// NOTIFICATIONS
	getMyNotifications: 'v1/notifications/my',
	getMyUnreadCount: 'v1/notifications/my/unread-count',
	markNotificationAsRead: 'v1/notifications',
	markAllMyNotificationsAsRead: 'v1/notifications/my/read-all',
	deleteNotification: 'v1/notifications',

	// APP UPDATES (Novedades: actualizaciones de la app y anuncios)
	getMyAppUpdates: 'v1/app-updates/my',
	getMyAppUpdatesUnreadCount: 'v1/app-updates/my/unread-count',
	getMyAppUpdatePopups: 'v1/app-updates/my/popups',
	getMyAppUpdateOffers: 'v1/app-updates/my/offers',
	markAppUpdateAsRead: 'v1/app-updates',
	markAllMyAppUpdatesAsRead: 'v1/app-updates/my/read-all',

	// AUCTIONS (Subastas)
	getAuctions: 'v1/auction',
	getAuctionById: (id: string) => `v1/auction/${id}`,
	getAuctionBids: (id: string) => `v1/auction/${id}/bids`,
	getMyAuctionBids: 'v1/auction/me/bids',
	pendingAuctionVictory: 'v1/auction/me/victory',
	markAuctionVictorySeen: (id: string) => `v1/auction/${id}/victory-seen`,
	placeAuctionBid: (id: string) => `v1/auction/${id}/bid`,
	auctionStreamPath: (id: string) => `v1/auctionEvents/stream/${id}`,
	auctionsStreamPath: 'v1/auctionEvents/stream',

	// RECARGAS (Recharges)
	listRechargeServices: 'v1/recharge/services',
	createRecharge: 'v1/recharge',
	checkRecharge: (reference: string) => `v1/recharge/${reference}`,
	checkRechargeDuplicates: 'v1/recharge/check-duplicates',

	// REFERRAL SOURCE
	createReferralSource: 'v1/accountManager/referral-source',

	// REFERRAL LINKS
	createReferralLink: 'v1/accountManager/referral-links',
	listReferralLinks: 'v1/accountManager/referral-links',
	validateReferralLink: (code: string) => `v1/accountManager/referral-links/validate/${code}`,
	deleteReferralLink: (id: string) => `v1/accountManager/referral-links/${id}`,

	// SERVICE ACCESS
	getServicesForAccount: (accountNumber: string) => `v1/service-access/services-for-account/${accountNumber}`,

	// CRYPTO CONTACT
	cryptoContact: 'v1/telegram/crypto-contact',

	// SUPPORT CHAT
	supportChatMessages: 'v1/support-chat/messages',
	supportChatUnreadCount: 'v1/support-chat/unread-count',
	supportChatTyping: 'v1/support-chat/typing',
	supportChatRead: 'v1/support-chat/read',
	supportChatAudioPlayed: (messageId: string) =>
		`v1/support-chat/messages/${messageId}/audio-played`,
	supportChatViewerState: 'v1/support-chat/viewer-state',
	supportChatNewConversation: 'v1/support-chat/new-conversation',
	supportChatAttachment: (objectKey: string) => `v1/support-chat/attachments/${encodeURIComponent(objectKey)}`,
	supportChatStream: 'v1/support-chat-events/stream',
};
